import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 15px;
  padding-left: 50px;
`

export const Row = styled(Container)`
  flex-direction: row;
  margin-bottom: 15px;
  padding: 0px;
  gap: 10px;
`

export const Title = styled.p`
  color: #000000;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 15px;
`
